import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Dialog, DialogContent, DialogHeader, DialogInner } from "../../../Common/UI/Index";
import { IRootState } from "../../../../reducer/CombineReducer";
import { VersioningSlice } from "./redux";
import { CreateVersion } from "./CreateVersionForm.logic";
import "./Style.scss";

/**
 * Responsible for rendering Create Version Dialog
 */
export const CreateVersionDialog: React.FC = (): JSX.Element => {

  const { t: translate } = useTranslation();
  const dispatch = useDispatch();
  const versioning = useSelector((state: IRootState) => state.versioning);
  const isToShow = versioning?.isToShowDialog;

  /**
   * Handler for dialog close button
   */
  const closeDialog = (): void => {
    dispatch(VersioningSlice.actions.showDialog(false));
  };

  return (
    <div className="ebt-version-create-dialog" id="ebt-version-create-dialog">
      {isToShow &&
        <Dialog
          open={isToShow}
          onOpenChange={closeDialog}
          className="ebt-extract__new-version"
        >
          <DialogInner   className="ebt-extract__new-version-inner">
            <DialogHeader
              className="ebt-extract__new-version-header"
            >
              <div>
                {translate("Versioning.Title")}
              </div>
            </DialogHeader>
            <DialogContent className="ebt-extract__new-version-content">
              {isToShow &&
                <CreateVersion />
              }
            </DialogContent>
          </DialogInner>
        </Dialog>
      }
    </div>
  );
};
